import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import CoreButtons from "../../../core-components/button/CoreButtons";
import {
	BUTTON_COLOR,
	BUTTON_VARIANT,
} from "../../../../types/coreButtonTypes";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import React, { FC, useMemo } from "react";
import "./directCallModal.css";
import { Box, Typography } from "@mui/material";
import PhoneCallIcon from "../../../../assets/svg-fc/PhoneCallIcon";
import {
	formatTollFreeNumberToLocalFormat,
	isUserOnMobile,
} from "../../../../utils/commonUtils";

interface iDirectCallModalProps {
	onClose: () => void;
	open: boolean;
	phoneNumber?: string;
	customerName?: string;
}

const DirectCallModal: FC<iDirectCallModalProps> = ({
	onClose,
	open,
	phoneNumber,
	customerName,
}) => {
	const [tollFreeNumber, CID] = useMemo(() => {
		const arr = phoneNumber?.split(",");
		return arr
			? [formatTollFreeNumberToLocalFormat(arr[0]), arr[1]]
			: ["", ""];
	}, [phoneNumber]);

	const isMobile = isUserOnMobile();
	return (
		<ModalBoxCore
			open={open}
			onClose={onClose}
			className="directCallModal"
		>
			<ModalBody>
				<Box className="callIconHolder">
					<PhoneCallIcon
						height={40}
						width={40}
					/>
				</Box>
				<Typography
					variant="h4"
					component="h4"
				>
					{isMobile
						? `Speak with ${customerName ?? ""}`
						: "Call this Customer"}
				</Typography>
				<p>
					{isMobile
						? "A call will be made to this customer from your phone on the number:"
						: "You can call this customer directly by dialing this number:"}
				</p>
				<a href={`tel:${phoneNumber}`}>
					Toll-free number: {tollFreeNumber}
				</a>
				<a href={`tel:${phoneNumber}`}>PIN number: {CID}</a>
				<p className="carrier-txt">(Carrier charges may apply)</p>
				{isMobile ? (
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							width: "100%",
						}}
						className="btn_link"
					>
						<CoreButtons
							className="callModalBtn"
							buttonText="Cancel"
							variant={BUTTON_VARIANT.OUTLINED}
							color={BUTTON_COLOR.SECONDARY}
							coreBtnPill={true}
							onclick={onClose}
						/>
						<a
							className="callModalLink"
							href={`tel:${phoneNumber}`}
						>
							Call
						</a>
					</Box>
				) : (
					<CoreButtons
						buttonText="Done"
						variant={BUTTON_VARIANT.CONTAINED}
						color={BUTTON_COLOR.PRIMARY}
						coreBtnPill={true}
						onclick={onClose}
						fullWidth={true}
					/>
				)}
			</ModalBody>
		</ModalBoxCore>
	);
};

export default DirectCallModal;
